import Vue from 'vue'
import dotObject from 'dot-object';

const CLIENT_ACTIVE = 1;
const CLIENT_BLOCKED = 2;
const CLIENT_BLACKLISTED = 3;
const CLIENT_VERIFICATION = 4;
const CLIENT_BANK_ACCOUNT_SELECT = 5;

const APPLICATION_NEW = 1;
const APPLICATION_SIGNING = 2;
const APPLICATION_ACCEPTED = 3;
const APPLICATION_COMPLETED = 4;
const APPLICATION_CANCELED = 5;
const APPLICATION_REJECTED = 6;
const APPLICATION_VERIFICATION = 7;
const APPLICATION_SPECIAL_OFFER = 13;
const APPLICATION_MANUAL_VERIFICATION = 14;
const APPLICATION_YHAT_DECREASE = 17;
const APPLICATION_YHAT_INCREASE = 18;
const APPLICATION_TERMINATED = 23;
const APPLICATION_DECISION_ERROR = 401;
const APPLICATION_DELAY_DECISION = 25;

const LOAN_DRAFT = 1;
const LOAN_CANCELLED = 2;
const LOAN_CAN_NOT_MAKE_OFFER = 3;
const LOAN_ACTIVE = 4;
const LOAN_PAID = 5;
const LOAN_ON_HOLD = 6;
const LOAN_TERMINATED = 8;
const LOAN_SOLD_DEBT = 9;
const LOAN_WRITE_OFF = 10;

const currency = '₼';

const DEFAULT_DECIMAL_PART = '00';

function twoDigit(str) {
  return `0${str}`.substr(-2);
}

Vue.filter('date', (value) => {
  if (!value) return '';
  const template = 'dd.mm.yyyy';

  let date = new Date(value);
  if (date instanceof Date && isNaN(date)) date = new Date(value.replace('+', '.'));

  const dd = twoDigit(date.getDate());
  const mm = twoDigit(date.getMonth() + 1);
  const yyyy = date.getFullYear();

  return template
    .replace('dd', dd)
    .replace('mm', mm)
    .replace('yyyy', yyyy);
});

Vue.filter('time', (value) => {
  if (!value) return '';

  let date = new Date(value);
  if (date instanceof Date && isNaN(date)) date = new Date(value.replace('+', '.'));

  const hh = twoDigit(date.getHours());
  const mm = twoDigit(date.getMinutes());

  return `${hh}:${mm}`;
});

Vue.filter('bigNumber', value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));

Vue.filter('money', (value) => {
  if (!value) return currency;

    const newValue = `${Math.ceil(value)}`;

  return `${Vue.options.filters.bigNumber(newValue).replace('.', '')} ${currency}`;
});

Vue.filter('moneyWithDecimal', value => {
  if (!value) return currency;

  const numberWithDecimal = (
      Math.round((Number.parseFloat(value) + Number.EPSILON) * 100) / 100
  ).toString();
  let decimalPart = numberWithDecimal.split('.')[1] || DEFAULT_DECIMAL_PART;
  if (decimalPart.length < 2) decimalPart += '0';

  return `${numberWithDecimal.split('.')[0]}.${decimalPart} ${currency}`;
});

Vue.mixin({
  methods: {
    $sr(path, base = this) {
      const value = dotObject.pick(path, base);

      return value === undefined ? '' : value;
    },
  },
});

export default (ctx, inject) => {
  ctx.store.registerModule('qa', {
    state: () => ({
      enabled: ctx.app.$cookies.get('qa-mode'),
    }),
  }, {
    preserveState: process.browser && !process.env.SPA,
  });

  Vue.directive('qa', {
    inserted(el, { value }) {
      if (ctx.store.state.qa.enabled) {
        el.setAttribute('data-qa-selector', value);
      }
    },
    update(el, { value }) {
      if (ctx.store.state.qa.enabled) {
        el.setAttribute('data-qa-selector', value);
      }
    },
  });

  const tools = {
    currency: {
      local: '₼',
      global: 'AZN',
    },
    format: {
      phone: '',
    },
    status: {
      CLIENT_ACTIVE,
      CLIENT_BLOCKED,
      CLIENT_BLACKLISTED,
      CLIENT_VERIFICATION,
      CLIENT_BANK_ACCOUNT_SELECT,

      APPLICATION_NEW,
      APPLICATION_SIGNING,
      APPLICATION_ACCEPTED,
      APPLICATION_COMPLETED,
      APPLICATION_CANCELED,
      APPLICATION_REJECTED,
      APPLICATION_VERIFICATION,
      APPLICATION_SPECIAL_OFFER,
      APPLICATION_MANUAL_VERIFICATION,
      APPLICATION_YHAT_DECREASE,
      APPLICATION_YHAT_INCREASE,
      APPLICATION_TERMINATED,
      APPLICATION_DECISION_ERROR,
      APPLICATION_DELAY_DECISION,

      LOAN_DRAFT,
      LOAN_CANCELLED,
      LOAN_CAN_NOT_MAKE_OFFER,
      LOAN_ACTIVE,
      LOAN_PAID,
      LOAN_ON_HOLD,
      LOAN_TERMINATED,
      LOAN_SOLD_DEBT,
      LOAN_WRITE_OFF,
    },
    downloadFile(response, name = 'download') {
      const type = response.headers['content-type'];
      const extension = type.split('/')[1];
      const url = window.URL.createObjectURL(new Blob([response.data], { type }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  };

  ctx.softRedirect = (path) => {
    const { redirect, route, app } = ctx;
    const newPath = path.replace('#', '');
    if (route.path === newPath) return;

    if (process.env.SPA) {
      app.router.push(newPath);
    } else {
      redirect(path);
    }
  };

  inject('tools', tools);
  ctx.$tools = tools;
}
